import { createTheme } from '../theme';

const theme = createTheme({
  components: {
    MuiLinearProgress: {
      defaultProps: {
        color: 'primary',
        variant: 'determinate',
      },
      styleOverrides: {
        root: ({ theme: { unstable_sx: sx, ...theme } }) =>
          sx({
            height: 6,
            bgcolor: theme.palette.grey['100'],
          }),
      },
    },
  },
});

export default theme.components;
